export default [
  'icon-huxingguanli',
  'icon-cheliangguanli',
  'icon-wuyegonggao',
  'icon-zuzhijiagou',
  'icon-fangyuanguanli',
  'icon-xitongguanli',
  'icon-cheweiguanli',
  'icon-shequguanli',
  'icon-luntan',
  'icon-huiyuanguanli',
  'icon-fangkeguanli',
  'icon-shequhuodong',
  'icon-lunboguanli',
  'icon-zhuhuguanli',
  'icon-jichugongneng',
  'icon-jifenguanli',
  'icon-linliquanzi',
  'icon-wuyebaoxiu',
  'icon-shenghuojiaofei',
  'icon-tingchejiaofei',
  'icon-renlianmenjin'
]